export default __webpack_public_path__ + "static/fingCLI-a95f25f49f5640f753d53f45c3c7d06a.webp";